import { useCallback, useEffect, useState } from "react";
import PendingAuthService from "../../../services/approvals.service";
import { useNavigate } from "react-router";
import { Breadcrumb, Card, Empty, Tabs, Button } from "antd";
import SelectAllCard from "../../../components/pending-approvals/selectAll";
import download from "../../../assests/icons/download_icon.png";
import { AiOutlineLeft } from "react-icons/ai";
import BillerCard from "../../../components/pending-approvals/biller";
import { ReactComponent as TitleIcon } from "../../../assests/images/transfer.svg";
import { useTranslation } from "react-i18next";
import BillerBeneGridItem from "../../../components/pending-approvals/history-grids/biller-bene-grid-item";
import BillerBeneFiciaryListItem from "../../../components/pending-approvals/history-lists/biller-bene-list";
import { ReactComponent as HomeIcon } from "../../../assests/images/home-line.svg";

export default function HistoryBiller() {
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState([]);
  const { t } = useTranslation();
  const [layout, setLayout] = useState("GRID");

  useEffect(() => {
    if (window.innerWidth < 900) {
      setLayout("LIST");
    }
  }, [window.innerWidth]);

  useEffect(() => {
    getPendingRecords();
  }, []);

  const getPendingRecords = useCallback(async () => {
    try {
      const response = await PendingAuthService.billerBeneGetRecords({
        listType: "A",
      });
      if (response.status === 200) {
        setDataSource(response.data);
      }
    } catch (error) {}
  }, []);

  const handleDownload = useCallback(async () => {
    try {
      const reqParams = {
        listType: "A",
      };
      await PendingAuthService.billerDownload(reqParams);
    } catch (err) {}
  }, []);

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/history")}>
              {t("navigation.history", {
                defaultValue: "History",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("navigation.biller_bene", {
                defaultValue: "Biller Beneficiary",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("navigation.biller_bene", {
                defaultValue: "Biller Beneficiary",
              })}
            </h3>
          </div>
          <div className=" col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-end">
            {dataSource.length === 0 ? null : (
              <Button
                type="default"
                className="btn-primary"
                onClick={handleDownload}
              >
                <img
                  alt="download"
                  src={download}
                  height={20}
                  style={{ paddingRight: "15px" }}
                />
                {t("buttons.download_btn", { defaultValue: "Download" })}
              </Button>
            )}
          </div>
        </div>
      </Card>
      <Card className="application-card">
        {layout === "GRID" && <BillerBeneGridItem dataSource={dataSource} />}

        {layout === "LIST" && (
          <BillerBeneFiciaryListItem dataSource={dataSource} />
        )}
      </Card>
    </>
  );
}
